module.exports = __webpack_public_path__ + "static/media/popchew-mouth.791aa900.png";